import { Component, OnInit } from '@angular/core';
import { GrowSurfParticipant } from '@app/shared/models/growsurf-participant';
import { ReferralsService } from '@app/shared/services/referrals/referrals.service';

declare var growsurf: any;

@Component({
  standalone: false,
  selector: 'sbnb-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss'],
})
export class ReferralsComponent implements OnInit {
  private participantData: GrowSurfParticipant;
  loading: boolean;
  error: boolean;

  constructor(private referralsService: ReferralsService) { }

  ngOnInit() {
    this.loading = true;

    this.referralsService.getGrowSurfParticipantData().subscribe(
      (res) => {
        this.participantData = res;

        console.log('Loading Growsurf...');

        setTimeout(() => {
          try {
            growsurf.init({
              email: this.participantData.email,
              hash: this.participantData.growsurf_hash,
            });

            this.loading = false;
          } catch (error) {
            alert(error);
            this.loading = false;
            this.error = true;
          }
        }, 5000);
      },
      (err) => {
        this.loading = false;
        this.error = true;
      }
    );
  }
}
